import { STORAGE_KEY_SOURCE_URL } from "raci-react-library-npe";

export let getB2CPCMBaseUrl: () => string | undefined;

/*
 ** WARNING: KNOW WHAT YOU'RE DOING BEFORE MAKING CHANGES TO
 ** TO THE BELOW IF STATEMENT.
 ** UPON A BUILD, VITE WILL REMOVE CODE IN
 ** THE OUTPUTTED JAVASCRIPT FILE DEPENDING ON THE TARGET
 ** ENVIRONMENT
 ** THIS MEANS THAT FOR LOCAL/DEV/SIT BUILDS WILL INCLUDE
 ** AND SHIP CODE (YOU CAN SEE AND SEARCH FOR IN OUTPUTTED
 ** JAVASCRIPT ARTIFACTS) FOR MICROSOFT AUTHENTICATION LIBRARY
 */
if (
  import.meta.env.VITE_ENVIRONMENT === "LOCAL" ||
  import.meta.env.VITE_ENVIRONMENT === "DEV" ||
  import.meta.env.VITE_ENVIRONMENT === "SIT" ||
  import.meta.env.VITE_ENVIRONMENT === "UAT"
) {
  getB2CPCMBaseUrl = () => {
    const url = sessionStorage.getItem(STORAGE_KEY_SOURCE_URL) ?? import.meta.env.VITE_B2C_PCM_BASE_URL;
    return decodeURIComponent(url ?? "");
  };
} else {
  getB2CPCMBaseUrl = () => import.meta.env.VITE_B2C_PCM_BASE_URL;
}

export const getB2CPCMUrl = (policyNumber: string) => `${getB2CPCMBaseUrl()}?policyNumber=${policyNumber}`;

export default getB2CPCMUrl;
